export const MuiAlert = palette => ({
  styleOverrides: {
    root: {
      backgroundColor: palette.surface.container,
      color: palette.surface.onSurface
    }
  }
})
